export const createStyles = () => ({
  trigger: {
    color: 'text.primary',
    m: -0.5,
    p: 0.5,
  },
  menu: {
    '& .MuiPaper-root': {
      bgcolor: 'background.paper',
      color: 'text.primary',
      mt: '4px',
      minWidth: '220px',
    },
  },
  modal: {
    bgcolor: 'background.paper',
    borderRadius: '8px',
    boxSizing: 'border-box',
    maxHeight: 'calc(100dvh - 32px)',
    outline: 'none',
    overflowY: 'auto',
    p: { xs: '16px', md: '24px' },
    width: { xs: 'calc(100vw - 32px)', md: '560px' },
  },
  modalHeader: {
    alignItems: 'flex-start',
    display: 'flex',
    gap: '16px',
    justifyContent: 'space-between',
    mb: '16px',
  },
  modalTitle: {
    color: 'text.primary',
    fontSize: '1.25rem',
    fontWeight: 600,
    letterSpacing: '0.15px',
    lineHeight: 1.6,
  },
  closeButton: {
    color: 'text.secondary',
    flexShrink: 0,
    mr: '-4px',
    mt: '-4px',
  },
  modalBody: { color: 'text.primary', mb: '24px' },
  message: {
    color: 'text.primary',
    fontSize: '1rem',
    lineHeight: 1.5,
    mb: '8px',
  },
  consequence: {
    color: 'text.secondary',
    fontSize: '0.875rem',
    lineHeight: 1.5,
  },
  modalFooter: {
    alignItems: 'center',
    display: 'flex',
    flexWrap: 'wrap',
    gap: '12px',
    justifyContent: 'flex-end',
    '& .MuiButton-root': {
      minHeight: '42px',
      minWidth: { xs: 'auto', sm: '128px' },
      textTransform: 'none',
    },
  },
  deleteButton: {
    bgcolor: 'error.main',
    color: 'error.contrastText',
    '&:hover': { bgcolor: 'error.dark' },
  },
});
